import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Language} from '../../types/common/language';
import {LanguageRestService} from '../../services/common/language-rest.service';

@Component({
  selector: 'wsd-select-language-ac',
  templateUrl: './select-language-ac.component.html',
  styleUrls: ['./select-language-ac.component.css']
})
export class SelectLanguageAcComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'SELECT_LANGUAGE.LABEL';

  @Input()
  controlName: string = 'language';

  @Input()
  showLabel: boolean = false;

  @Input()
  allowedLanguages: string[] = [];

  languages: Language[] = [];

  allLanguages: Language[] = [];

  constructor(private languagesRestService: LanguageRestService) { }

  ngOnInit() {
    this.initLanguages();
  }

  private initLanguages() {
    this.languagesRestService.findAllLanguages().subscribe(
      (languages: Language[]) => this.allLanguages = this.getAllowedLanguages(languages)
    );
  }

  private getAllowedLanguages(languages: Language[]) {
    return this.allowedLanguages.length ?
      languages.filter(lang => this.allowedLanguages.includes(lang.name)) : languages;
  }

  filterLanguages(event) {
    this.filterBy(event.query);
  }

  private filterBy(query: string) {
    this.languages = [];
    for (const language of this.allLanguages) {
      if (language.name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
        this.languages.push(language);
      }
    }
  }

}
